<template>
  <base-container>
    <h2 class="yahoo-title">日本Yahoo拍賣 最熱賣產品</h2>
  </base-container>
  <el-carousel
    :interval="5000"
    trigger="click"
    arrow="always"
    indicator-position="none"
    height="330px"
  >
    <el-carousel-item>
      <base-container>
        <el-row :gutter="12">
          <el-col :span="6" v-for="product in products" :key="product.id">
            <rakuten-card
              :name="product.name"
              :description="product.description"
              :price="product.price"
              :discountPrice="product.discountPrice"
              :isRakutenProduct="product.isRakutenProduct"
            ></rakuten-card>
          </el-col>
        </el-row>
      </base-container>
    </el-carousel-item>
  </el-carousel>
  <div class="w3-center">
    <el-button class="btn">顯示全部</el-button>
  </div>
</template>

<script>
import RakutenCard from "../RakutenCard.vue";

export default {
  components: {
    RakutenCard,
  },
  data() {
    return {
      products: [
        {
          id: 1,
          name: "日本YAHOO拍賣",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: false,
        },
        {
          id: 2,
          name: "日本YAHOO拍賣",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: false,
        },
        {
          id: 3,
          name: "日本YAHOO拍賣",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: false,
        },
        {
          id: 4,
          name: "日本YAHOO拍賣",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: false,
        },
      ],
    };
  },
};
</script>

<style scoped>
.yahoo-title {
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 2rem;
}
.btn {
  /* margin-top: 1rem; */
  padding: 8px 120px;
  border-radius: 8px;
  border: 1px solid #4b4b4b !important;
}

@media only screen and (max-width: 1139px) {
  .btn {
    margin-top: 1.5rem;
  }
}
</style>